// src/auth/phoneAuth.ts
import { RecaptchaVerifier, signInWithPhoneNumber, ConfirmationResult } from 'firebase/auth';
import { auth } from '../config/firebase';

let recaptchaVerifier: RecaptchaVerifier | null = null;
let recaptchaWidgetId: number | null = null;

export const setupRecaptcha = () => {
    const container = document.getElementById('recaptcha-container');
    if (!container) {
        throw new Error('reCAPTCHA container not found in DOM');
    }

    if (recaptchaVerifier) {
        console.log('Reusing existing reCAPTCHA instance');
        return recaptchaVerifier;
    }

    try {
        console.log('Creating new reCAPTCHA instance');
        recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
            size: 'invisible',
            callback: (response: any) => {
                console.log('reCAPTCHA solved, response:', response);
            },
            'expired-callback': () => {
                console.log('reCAPTCHA expired');
                clearRecaptcha();
            },
        });

        recaptchaVerifier.render().then((widgetId) => {
            console.log('reCAPTCHA rendered, widget ID:', widgetId);
            recaptchaWidgetId = widgetId;
        }).catch((error) => {
            console.error('Error rendering reCAPTCHA:', error);
            recaptchaVerifier = null;
            throw error;
        });
    } catch (error) {
        console.error('Error setting up reCAPTCHA:', error);
        clearRecaptcha();
        throw error;
}

    return recaptchaVerifier;
};

export const clearRecaptcha = () => {
    console.log('Clearing reCAPTCHA...');
    
    if (recaptchaVerifier) {
        try {
            // Try to clear the verifier
            recaptchaVerifier.clear();
            console.log('reCAPTCHA verifier cleared successfully');
        } catch (error) {
            console.error('Error clearing reCAPTCHA verifier:', error);
        } finally {
            recaptchaVerifier = null;
            recaptchaWidgetId = null;
        }
    }

    //Clear the container content
    const container = document.getElementById('recaptcha-container');
    if (container) {
        container.innerHTML = '';
        console.log('reCAPTCHA container cleared');
    }
};

export const sendVerificationCode = async (
    phoneNumber: string
): Promise<ConfirmationResult> => {
    try {
        const verifier = setupRecaptcha();
        console.log('About to call signInWithPhoneNumber in sendVerificationCode with phone:', phoneNumber);
        console.log('Current verifier object:', verifier);

        const result = await signInWithPhoneNumber(auth, phoneNumber, verifier);
        console.log('signInWithPhoneNumber triggered, SMS was sent:', result);

        return result;
    } catch (err: any) {
        console.error('signInWithPhoneNumber failed:', err);
        if (err?.code) {
            console.error('Firebase error code:', err.code);
        }
        if (err?.message) {
            console.error('Firebase error message:', err.message);
        }
        throw err; 
    }
};

export const confirmVerificationCode = async (
    confirmationResult: ConfirmationResult,
    code: string
): Promise<string> => {
    try {
        console.log('About to confirm verification code:', code);
        console.log('ConfirmationResult object:', confirmationResult);

        const userCredential = await confirmationResult.confirm(code);
        console.log('Verification successful. UserCredential:', userCredential);

        const idToken = await userCredential.user.getIdToken();
        console.log('Retrieved ID Token:', idToken);

        return idToken;
    } catch (err: any) {
        console.error('Error during confirmVerificationCode:', err);
        if (err?.code) {
            console.error('Firebase error code:', err.code);
        }
        if (err?.message) {
            console.error('Firebase error message:', err.message);
        }

        throw err;
    }
};
